import { useQuery } from "@tanstack/react-query";
import type { DelayForPareto } from "../../delays-pareto/models/DelayForPareto";
import { getDelaysForPareto } from "../../delays-pareto/repositories/DelaysParetoRepository";

export const useDelaysForParetoQuery = (
  params: {
    startDate: Date;
    endDate: Date;
    delayAreaAssetId: number | null;
    includeMicroDelays: boolean;
    includeUndeclaredDelays: boolean;
  },
  onError?: (error: Error) => void,
) => {
  return useQuery({
    queryKey: [
      "delays-for-pareto",
      params.startDate.toISOString(),
      params.endDate.toISOString(),
      params.delayAreaAssetId,
      params.includeMicroDelays,
      params.includeUndeclaredDelays,
    ],
    queryFn: async ({ signal }) => {
      const resp = await getDelaysForPareto({ ...params, signal });
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as DelayForPareto[];
      }
      throw new Error(resp.message);
    },
    enabled: !!params.startDate && !!params.endDate,
    onError,
  });
};
